// @subframe/sync-disable

"use client";
/*
 * Documentation:
 * Dc_Text_Glossar_Unsynced — https://app.subframe.com/4f62853ee923/library?component=Dc_Text_Glossar_Unsynced_266ecbd5-b3a1-420a-b67b-da10c94a57a5
 * GlossaryTooltip — https://app.subframe.com/4f62853ee923/library?component=GlossaryTooltip_2f0f9c8c-6ad9-440d-bf4a-ccd1466e9d5c
 */

import React from "react";
import * as SubframeCore from "@subframe/core";
import * as SubframeUtils from "../utils";
import { GlossaryTooltip } from "./GlossaryTooltip";

interface Dc_Text_Glossar_UnsyncedRootProps
  extends React.HTMLAttributes<HTMLSpanElement> {
  text?: React.ReactNode;
  tooltipContent?: React.ReactNode;
  className?: string;
}

const Dc_Text_Glossar_UnsyncedRoot = React.forwardRef<
  HTMLSpanElement,
  Dc_Text_Glossar_UnsyncedRootProps
>(function Dc_Text_Glossar_UnsyncedRoot(
  {
    text,
    tooltipContent,
    className,
    ...otherProps
  }: Dc_Text_Glossar_UnsyncedRootProps,
  ref
) {
  return text ? (
    <SubframeCore.Tooltip.Provider delayDuration={100}>
      <SubframeCore.Tooltip.Root>
        <SubframeCore.Tooltip.Trigger asChild={true}>
          <span
            className={SubframeUtils.twClassNames(
              "text-body font-body text-default-font underline decoration-1 decoration-dotted underline-offset-2 cursor-help",
              className
            )}
            ref={ref}
            {...otherProps}
          >
            {text}
          </span>
        </SubframeCore.Tooltip.Trigger>
        <SubframeCore.Tooltip.Portal>
          <SubframeCore.Tooltip.Content
            side="top"
            align="center"
            sideOffset={8}
            asChild={true}
          >
            <div className="flex flex-col items-start gap-2">
              <GlossaryTooltip className="h-auto w-auto max-w-[448px] flex-none">
                {tooltipContent}
              </GlossaryTooltip>
            </div>
          </SubframeCore.Tooltip.Content>
        </SubframeCore.Tooltip.Portal>
      </SubframeCore.Tooltip.Root>
    </SubframeCore.Tooltip.Provider>
  ) : null;
});

export const Dc_Text_Glossar_Unsynced = Dc_Text_Glossar_UnsyncedRoot;
